import type { Route } from 'next'
import { isRole, type Role } from '@nivex/contracts'

/**
 * Where each role's own shell lives — the single source of truth for role-based redirects.
 *
 * `investor` is cast because `/dashboard` has no page right now — the investor dashboard
 * was removed pending a rebuild (see project notes). Remove the cast once it exists again.
 */
export const ROLE_HOME: Record<Role, Route> = {
  investor: '/dashboard' as Route,
  staff: '/staff',
  admin: '/admin',
}

/**
 * Narrows a Clerk session's custom `role` claim to this app's `Role` type. Returns `null`
 * for a missing/invalid claim rather than defaulting to any particular role — same
 * fail-closed policy the backend's `ClerkAuthGuard` already applies to the same claim (see
 * `role.ts` in `@nivex/contracts`).
 */
export function roleFromSessionClaims(
  sessionClaims: { role?: unknown } | null | undefined,
): Role | null {
  return isRole(sessionClaims?.role) ? sessionClaims.role : null
}
